<div class="flex flex-col justify-center items-center gap-2 text-center py-2">
  <img
    src="https://storage.googleapis.com/komerce/rajaongkir/tour-end.png"
    onerror="this.src='https://storage.googleapis.com/komerce/rajaongkir/rocket-bg-orange.svg'"
    alt="Akhir Tour"
    class="w-16 h-16 mb-2"
  />
  <span class="text-lg font-semibold text-primary">Akhir dari Tour</span>
  <p class="text-sm text-muted leading-relaxed">
    Tour fitur {{ serviceName }} sudah selesai, untuk petunjuk fitur
    lainnya, anda bisa menekan kembali tombol (?) di dashboard. Terimakasih!
  </p>
  <button nz-button nzType="primary" class="w-full mt-2" (click)="handleFinish()">
    Selesai Tour
  </button>
</div>
